import { createContext } from "react";

export const UserManagerContext = createContext({
  userManager: null,
  setUserManager: () => {},
});
